import { render, staticRenderFns } from "./countprice.vue?vue&type=template&id=45f0b1fc&scoped=true&"
import script from "./countprice.vue?vue&type=script&lang=js&"
export * from "./countprice.vue?vue&type=script&lang=js&"
import style0 from "./countprice.vue?vue&type=style&index=0&id=45f0b1fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f0b1fc",
  null
  
)

export default component.exports